<template>

    <div v-if="statuses">

        <h3 class="text-xl font-bold text-gray-900 mb-4">{{ assignment.title }}</h3>
            
        <p v-if="assignment.description" class="mb-4">{{ assignment.description }}</p>

        <div class="sm:rounded-md mb-4">
            <div class="px-4 py-5 rounded-md" :class="assignment.status == 2 ? 'bg-green-300' : (assignment.status == 3 ? 'bg-red-300' : 'bg-yellow-200')">
                Status: <span v-if="assignment.status == 1">Pending</span>
                <span v-else-if="assignment.status == 2">Accepted</span>
                <span v-else-if="assignment.status == 3">Rejected</span>
            </div>
        </div>

        <div v-for="(row_status, status_key) in statuses" :key="'status-' + status_key">
            <div class="sm:rounded-md mb-4 border border-gray-200">
                <div class="px-4 py-5 bg-gray-50 sm:p-6 sm:rounded-t-md">
                        
                    <div class="bg-gray-800 text-sm rounded-full float-right">
                        <div class="h-10 w-10 rounded-full overflow-hidden text-white">
                            <ProfileImage :image="row_status.profile_image"/>
                        </div>
                    </div>

                    <p :class="row_status.upload ? 'mb-4' : ''" v-if="row_status.description">{{ row_status.description }}</p>

                    <div v-if="row_status.upload">
                        <p>
                            <a :href="row_status.upload.url" target="_blank" class="border font-medium shadow-sm focus:outline-none transition duration-150 ease-in-out py-2 px-3 border border-gray-300 text-sm leading-4 font-medium text-gray-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-600 hover:text-gray-500 active:bg-gray-50 active:text-gray-800 transition duration-150 ease-in-out py-2 px-4 text-sm leading-5 rounded-full relative">View {{ assignmentLabel }}</a>
                        </p>
                    </div>

                    <div class="clear-both"></div>
                </div>
                <div class="px-4 py-3 bg-gray-200 sm:px-6 sm:rounded-b-md">
                    <p class="text-sm text-gray-500">Added by {{ row_status.user.firstname + ' ' + row_status.user.lastname }}, <CalendarFormat :date="row_status.created_at" :showState="false"/></p>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>

import CalendarFormat from "@/Components/CalendarFormat";
import ProfileImage from "@/Components/ProfileImage.vue"
import {optionsToArray} from "@/Lib/Helpers";
import axios from "axios";

export default {

    name: "AssignmentStatuses",

    props: {
        assignment: {
            type: Object,
            default: () => ({})
        },
        assignmentLabel: {
            type: String,
            default: () => 'Assignment'
        },
        statuses: {
            type: Array,
            default: () => ({})
        },
    },

    data() {
        return {
            loaded: false,
            courses: [],
        };
    },

    components: {
        CalendarFormat,
        ProfileImage,
    },
};

</script>
